import { ImpersonateData } from '../../helpers/session';
import { loadCookieData, saveCookieData } from '../../helpers/cookie-data';
import { CoreUser, CoreUserOrganization } from '@densityco/lib-api-types';

export function loadImpersonateData(): ImpersonateData {
  return loadCookieData().impersonate;
}

export function saveImpersonateData(impersonateData: ImpersonateData): void {
  const cookieData = loadCookieData();
  cookieData.impersonate = impersonateData;
  saveCookieData(cookieData);
}

export type ImpersonateState = {
  enabled: boolean;

  impersonateData: ImpersonateData;

  users: {
    status: 'IDLE' | 'LOADING' | 'ERROR' | 'COMPLETE';
    data: Array<CoreUser>;
    selected: {
      id: CoreUser['id'];
      email: CoreUser['email'];
      full_name: CoreUser['full_name'];
      role: CoreUser['role'];
    } | null;
    search: string;
  };
  organizations: {
    status: 'IDLE' | 'LOADING' | 'ERROR' | 'COMPLETE';
    data: Array<CoreUserOrganization>;
    selected: {
      id: CoreUserOrganization['id'];
      name: CoreUserOrganization['name'];
    } | null;
    search: string;
  };
  createOrganizationError: string | null;
};

export function getInitialState(): ImpersonateState {
  const data = loadImpersonateData();

  if (!data.enabled) {
    return {
      enabled: data.enabled,

      impersonateData: data,

      users: {
        status: 'IDLE',
        data: [],
        selected: null,
        search: '',
      },
      organizations: {
        status: 'IDLE',
        data: [],
        selected: null,
        search: '',
      },
      createOrganizationError: null,
    };
  }

  return {
    enabled: data.enabled,

    impersonateData: data,

    users: {
      status: 'IDLE',
      data: [],
      selected: {
        id: data.id,
        email: data.email,
        full_name: data.name,
        role: data.role,
      },
      search: '',
    },

    organizations: {
      status: 'IDLE',
      data: [],
      selected: {
        id: data.organizationId,
        name: data.organizationName,
      },
      search: '',
    },

    createOrganizationError: null,
  };
}
